/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:  2023-07-26 08:00:56
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React from 'react';
import { Field } from 'redux-form';
import { Icon, SkeletonDisplayText } from '@shopify/polaris';
import { DragHandleMinor } from '@shopify/polaris-icons';
import { withI18n } from '@shopify/react-i18n';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import type { DropResult } from 'react-beautiful-dnd';

const OptionsTable = props => {
  const { fields, loading, suggestionBlocks } = props;

  const onDragEnd = (result: DropResult) => {
    // dropped outside the list
    if (!result.destination || result.destination.index === result.source.index) {
      return;
    }

    // no movement
    if (result.destination.index === result.source.index) {
      return;
    }

    fields.move(result.source.index, result.destination.index);
  };

  return (
    <div>
      <DragDropContext onDragEnd={onDragEnd}>
        {loading ? (
          <div>
            {[...Array(2).keys()].map((item, key) => (
              <div key={key}>
                {[...Array(4).keys()].map((item, key) => (
                  <div className="block-content" key={key}>
                    <SkeletonDisplayText size="small" />
                  </div>
                ))}
              </div>
            ))}
          </div>
        ) : (
          !_.isEmpty(fields) && (
            <Droppable droppableId="droppableOrderContent">
              {provided => (
                <div
                  className="BC-Draggable__Container"
                  ref={provided.innerRef}
                  {...provided.droppableProps}>
                  {fields.map((item, key) => {
                    const { type = 'type', label = '' } = suggestionBlocks[key];

                    return (
                      // Enable drag for per option row
                      <Draggable draggableId={`${type}-${key}`} key={`${type}-${key}`} index={key}>
                        {(provided, snapshot) => (
                          <div
                            className="block-order"
                            ref={provided.innerRef}
                            {...provided.dragHandleProps}
                            {...provided.draggableProps}>
                            {/* Drag icon */}
                            <div className="block-icon">
                              <Icon color="base" source={DragHandleMinor} />
                            </div>

                            {/* Content type */}
                            <div className="block-label">
                              <Field component="input" name={`${item}.type`} type="hidden" />
                              <p>{label}</p>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          )
        )}
      </DragDropContext>
    </div>
  );
};
export default withI18n()(OptionsTable);
